<template>
  <div>
    <table
      v-if="paginatedItems.length > 0"
      class="table table-bordered min-w-full"
    >
      <thead>
        <tr>
          <th v-for="header in headers" :key="header.key" class="p-3">
            {{ header.label }}
          </th>
          <th v-if="hasActions" class="p-3">Ações</th>
        </tr>
      </thead>

      <tbody>
        <tr
          v-for="(item, index) in paginatedItems"
          :key="`${item.idPropostaNota}${index}`"
        >
          <td v-for="header in headers" :key="header.key" class="p-2">
            {{ formatField(item, header.key, header.isTime, header.isDate) }}
          </td>
          <td v-if="hasActions" class="p-2 flex items-center justify-center">
            <GenericActionButtons :buttons="buttons" :item="item" />
          </td>
        </tr>
      </tbody>
    </table>

    <div v-else>
      <p>Não existe histórico de mensagens para essa proposta.</p>
    </div>

    <div v-if="totalPages > 1" class="pagination">
      <button
        @click="goToPage(page - 1)"
        :disabled="page === 1"
        class="bg-grey-button-previous w-10 h-10 rounded-full border-none p-2"
      >
        <vs-icon icon-pack="feather" icon="icon-chevron-left"></vs-icon>
      </button>
      <button
        @click="goToPage(page + 1)"
        :disabled="page === totalPages"
        class="bg-grey-button-next w-10 h-10 rounded-full border-none p-2 pointer"
      >
        <vs-icon icon-pack="feather" icon="icon-chevron-right"></vs-icon>
      </button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import GenericActionButtons from './GenericActionButtons.vue';

export default {
  name: 'GenericTable',
  props: {
    headers: Array,
    items: Array,
    buttons: Array,
    onDelete: Function,
    itemsPerPage: {
      type: Number,
      default: 10,
    },
  },
  components: {
    GenericActionButtons,
  },
  data() {
    return {
      page: 1,
    };
  },
  computed: {
    hasActions() {
      return this.buttons && this.buttons.length > 0;
    },
    totalPages() {
      return Math.ceil(this.items.length / this.itemsPerPage);
    },
    paginatedItems() {
      const startIndex = (this.page - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      return this.items.slice(startIndex, endIndex);
    },
  },
  methods: {
    formatField(item, key, isTime, isDate) {
      const value = key.split('.').reduce((acc, curr) => acc[curr], item);
      if (isTime) {
        return this.formatTime(value);
      }
      if (isDate) {
        return this.formatDate(value);
      }

      return value;
    },

    formatDate(dateTime) {
      return moment(dateTime).format('DD/MM/YYYY');
    },

    formatTime(dateTime) {
      return moment(dateTime).format('HH:mm');
    },

    goToPage(newPage) {
      if (newPage >= 1 && newPage <= this.totalPages) {
        this.page = newPage;
      }
    },
  },
  watch: {
    items: {
      handler() {
        this.page = 1;
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
.pagination {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pagination button {
  margin: 0 5px;
}
</style>
